import $ from 'jquery'
import 'slick-carousel/slick/slick.min'

$(document).ready(function() {
  dhsv_vc_photo_gallery()
})

function dhsv_vc_photo_gallery() {
  $('.photo-gallery').each(function() {
    $(this).on('init', function() {
      $(this)
        .find('.slick-dots')
        .prepend(
          '<button class="slick-prev slick-arrow"><i class="ion ion-ios-arrow-back"></i></button>'
        )
      $(this)
        .find('.slick-dots')
        .append(
          '<button class="slick-next slick-arrow"><i class="ion ion-ios-arrow-forward"></button>'
        )
      $('.slick-dots .slick-prev').on('click', function() {
        $('.photo-gallery > .slick-arrow.slick-prev').trigger('click')
      })
      $('.slick-dots .slick-next').on('click', function() {
        $('.photo-gallery > .slick-arrow.slick-next').trigger('click')
      })
    })
    $(this).slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      slidesPerRow: 3,
      rows: 2,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesPerRow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesPerRow: 1,
          },
        },
      ],
    })
  })
}
